import { memo, useCallback, useMemo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import styles from './Filter.module.scss';

const Filter = ({
  label,
  value,
  isActive,
  onClick,
  Icon,
  iconType = 'fill',
}) => {
  const handleClick = useCallback(() => onClick(value), [onClick, value]);

  const iconProps = useMemo(
    () =>
      iconType === 'stroke'
        ? { stroke: 'currentColor' }
        : { fill: 'currentColor' },
    [iconType],
  );

  return (
    <div
      onClick={handleClick}
      className={classNames(styles.root, {
        [styles.active]: isActive,
      })}
    >
      <Icon {...iconProps} />
      <Typography weight="medium" color="inherit">
        {label}
      </Typography>
    </div>
  );
};

Filter.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  Icon: PropTypes.elementType.isRequired,
  iconType: PropTypes.oneOf(['fill', 'stroke']),
};

export default memo(Filter);
